import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Calorie counting is silly",
  "description": "",
  "published": "2011-09-20T00:00:00.000Z",
  "redirect_from": ["/blog/calorie-counting-is-silly/swizec/2474"],
  "categories": "Calorie, Eating, Food, Geocities, Health, IPhone, Learning, Personal, Weight loss",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Red_Devil_energy_drink1.jpg",
        "alt": "A can of Red Devil.",
        "title": "A can of Red Devil."
      }}></img></p>
    <p>{`The idea of a data driven lifestyle has really started gaining ground lately. It seems every month at least one such application comes out. Some call it gamification of the world around you, some just want to help you lead a better lifestyle. All have one thing in common:`}</p>
    <p>{`Collecting reams upon reams of data you didn't think you needed even a week ago.`}</p>
    <p>{`Sometime last year I somehow got sucked into this cult as well. My `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gateway_drug_theory",
        "title": "Gateway drug theory"
      }}>{`gateway drug`}</a>{` was `}<a parentName="p" {...{
        "href": "http://www.foursquare.com/",
        "title": "Foursquare"
      }}>{`Foursquare`}</a>{` - it made me start logging my locations to see where I've been. "For the lulz!", so to say.`}</p>
    <p>{`But then I started using an app called `}<a parentName="p" {...{
        "href": "http://www.daytum.com/",
        "title": "Daytum"
      }}>{`Daytum`}</a>{` that lets you log pretty much any random thing and I've been using it to great effect mostly for keeping tabs on how many `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Energy_drink",
        "title": "Energy drink"
      }}>{`energy drinks`}</a>{` and cups of tea I drink in a day, but also to keep track of my morning exercising. Toshl is another important mention at this point, I've never analyzed that data, but just the constant nagging blatant reminder of how much I'm spending makes me behave more responsibly ... I think.`}</p>
    <p>{`Well, last week I got suckered into counting calories. I'm still not sure how exactly it happened. One moment I'm having a normal conversation, next thing I know I'm downloading an app and thinking about what I'd eaten that day so I could start logging right then and there.`}</p>
    <p>{`It's important to always start `}<em parentName="p">{`NOW`}</em>{`. Not tomorrow. Not next week. `}<em parentName="p">{`Now!`}</em></p>
    <p>{`I'm using `}<a parentName="p" {...{
        "href": "http://www.myfitnesspal.com/"
      }}>{`MyFitnessPal.com`}</a>{` and it's looking pretty good so far. Their web interface sucks more than your average `}<a parentName="p" {...{
        "href": "http://www.geocities.co.jp/",
        "title": "GeoCities"
      }}>{`Geocities`}</a>{` website, but the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/IPhone",
        "title": "IPhone"
      }}>{`iPhone app`}</a>{` itself is pretty damn cool. Must admit I find it almost reasonably simple to use and can actually navigate around well enough to accomplish most of my tasks without too much effort.`}</p>
    <p>{`But the damn thing keeps trying to make me eat and eat and eat and then eat some more. Not sure exactly who designed this system, but it seems to be primarily aimed at people trying to lose weight. My settings say that I want to maintain body weight.`}</p>
    <p>{`Now, myfitnesspal also lets you add exercises and what invariably ends up happening for me is that despite feeling full and perfectly content with how much I've eaten on any given day ... it wants more. Take today for example, I've eaten 1928 calories, which is pretty respectable if you ask me. Well, myfitnesspal thinks I should eat another 333 calories.`}</p>
    <p>{`The most interesting in this story is the effect of `}<em parentName="p">{`seeing`}</em>{` how many calories I'm eating is having the exact opposite effect myfitnesspal is trying to convince me it should have. I'm fairly certain I'm eating `}{`_`}{`less `}{`_`}{`than I was before, which would be awesome if I was trying to lose weight, but I'm not.`}</p>
    <p>{`Seeing all those calories gives me this subconscious sense of guilt when I eat. It's really difficult to explain, but I'm thinking it's the same effect writing down expenses has.`}</p>
    <p>{`Also, it's only Wednesday and I've already blown my weekly ration of sugar by four grams ...`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fitsugar.com/5848166"
        }}>{`Do You Count Calories?`}</a>{` (fitsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eatspinrunrepeat.wordpress.com/2011/09/20/readers-request-how-to-get-healthy/"
        }}>{`Reader's Request: How to "get healthy"`}</a>{` (eatspinrunrepeat.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fitsugar.com/2498686"
        }}>{`Back to Basics: Calories Explained`}</a>{` (fitsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://maureenholland.wordpress.com/2011/09/20/you-want-fries-with-that/"
        }}>{`You want fries with that?`}</a>{` (maureenholland.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eating.health.com/2011/09/19/nighttime-eating-weight-gain/"
        }}>{`Why Nighttime Calories Are Worse for Your Waist`}</a>{` (eating.health.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=992632bd-807f-4c20-8ac5-5ba918070413",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      